import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import {
  GiveawayLiveDrawSlotMachine,
  GiveawayResultSlotMachine
} from 'src/sections/giveaway-menu/view';

// ----------------------------------------------------------------------

// OVERVIEW
const OverviewEcommercePage = lazy(() => import('src/pages/dashboard/econmerce-user'));
const ProductDetailsPage = lazy(() => import('src/pages/dashboard/product/details'));
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/user-profile'));
const ParticipatedInPage = lazy(() => import('src/pages/dashboard/giveaway/ParticipatedIn'));
const ParticipatePage = lazy(() => import('src/pages/dashboard/giveaway/Participate'));
const HomePage = lazy(() => import('src/pages/home'));
const UpcomingDrawPage = lazy(() => import('src/pages/dashboard/giveaway/UpcomingDraw'));
// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <OverviewEcommercePage />, index: true },
      // { path:'home', element: <HomePage dashboard={true} /> },
      { path: 'user/profile', element: <UserProfilePage /> },
      {
        path: 'giveaway', children: [
          { element: <ParticipatedInPage />, index: true },
          { path: "participated-in", element: <ParticipatedInPage /> },
          { path: "upcoming-draw", element: <UpcomingDrawPage /> },
          { path: 'participate', element: <ParticipatePage /> },
          { path: "detail/:id", element: <ProductDetailsPage /> },
          { path: 'live-draw/:id', element: <GiveawayLiveDrawSlotMachine /> },
          { path: "result/:id", element: <GiveawayResultSlotMachine /> },
        ]
      }
    ],
  },
];
